<template>
<header>
    メモ
    <div class="h-left">
        <a @click="redirectBack()"><img src="~@/assets/images/icon02.svg" /></a>
    </div>
</header>
<div id="wrap3">
    <header class="menu" v-if="metadata">
    <ul id="header" class="h-menu3 clearfix">
        <li
          v-for="(item, index) in metadata.memo_category"
          :key="index"
          :class="`item ${index == 1 ? 'active-item' : 'menu-item'}`"
          @click="changeType(parseInt(index))"
        >
            {{item}}
        </li>
        
    </ul>
        </header>
    <div v-if="!isEdit">
        <a v-for="(item, index) in memoList" :key="index" @click="edit(item)">
            <div class="list">
                <div class="clearfix">
                    <div class="list-img"><img :src="getImageUrl(item.avatar_url)" /></div>
                    <div class="list-inf">
                        <table>
                            <tr>
                                <td>
                                    <p>
                                        <i class="fas fa-file-alt"></i>
                                        <span class="list-name">{{ ' ' + item.display_name }} {{ item.age }}歳 {{ getFieldProfile('living_area', item.living_area) }}</span>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p class="note" style="min-height: 1.5em">
                                        {{ item.content }}
                                    </p>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </a>
        <infinite-loading @infinite="getMemo" spinner="spiral" :identifier="infiniteId">
            <template v-slot:no-more></template>
            <template v-slot:no-results>
                <div id="middle">
                    <p><img src="~@/assets/images/note.png" width="150"><br><br>まだ登録されたメモはありません</p>
                </div>
            </template>
        </infinite-loading>
    </div>
</div>
<editMemo v-if="isEdit" :isShow="isEdit" :memoDetail="memoDetail" @delete="deleteMemo" @submit="submitEdit"></editMemo>

<div class="loading-screen" style="opacity: 0.8" v-if="isLoading">
    <div class="loader"></div>
</div>

<alertDialogBottom :active="isAlert">
    メモを保存しました。
</alertDialogBottom>

</template>

<script>
import {
    mapActions,
    mapGetters
} from "vuex"
import CONSTANTS from "@/constants"
import editMemo from "./components/editMemo"
import mixin from "@/mixin"
import alertDialogBottom from "@/views/components/alertDialogBottom.vue";
export default {
    components: {
        editMemo,
        alertDialogBottom
    },
    mixins: [mixin],
    data: () => ({
        isGet: true,
        category: 1,
        memoList: [],
        state: null,
        infiniteId: 0,
        isEdit: false,
        isClickEdit: false,
        memoDetail: null,
        isAlert: false,
        isLoading: false,
        scrollPosition: 0
    }),
    mounted() {
        this.setFooter(false)
        this.scrollMenu()
    },
    watch: {
        isEdit(val) {
            if (val) {
                this.setScrollPosition();
                setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 10);
            } else {
                this.scrollToPosition();
            }
        }
    },
    computed: {
        ...mapGetters(['defaultToken', 'metadata']),
    },
    methods: {
        ...mapActions({
            setFooter: 'layout/setFooter',
        }),
        changeType(type) {
            this.memoList = []
            this.category = type
            this.isGet = true
            this.isEdit = false
            this.isClickEdit = false
            this.infiniteId++
            window.scrollTo(0, 0)
        },
        async getMemo($state = null) {
            if (this.isClickEdit) {
                $state.loaded()
            }

            if ($state) {
                this.state = $state
            }
            if (this.isGet) {
                await this.$store.dispatch('profile/getMemo', {
                    token: this.defaultToken,
                    category: this.category
                }).then(data => {
                    if (data[0]) {
                        this.memoList.push(...data)
                        if ($state) {
                            $state.loaded()
                        }
                        // this.memoList = this.memoList.filter(item => {
                        //     return parseInt(item.category) === this.category
                        // })
                        this.isGet = false
                    } else {
                        if ($state) {
                            $state.complete()
                        }
                        this.isGet = false
                    }

                }).catch(() => {
                    if ($state) {
                        $state.complete()
                    }
                })
            } else {
                if ($state) {
                    $state.complete()
                }
            }
        },
        getFieldProfile(field, id) {
            if (!this.metadata.user_profile_list) return null
            let filedData = this.metadata.user_profile_list[field].filter((item) => {
                return parseInt(item.value) === parseInt(id);
            });
            if (filedData[0]) {
                return filedData[0].name;
            }
            return CONSTANTS.NOT_VALUE;
        },
        edit(item) {
            this.memoDetail = item
            this.isEdit = true
            this.isClickEdit = true;
        },
        deleteMemo(formData) {
            let form = new FormData()
            form.append('id', formData.memoId)
            form.append('token', this.defaultToken)
            this.$store.dispatch('profile/deleteMemo', form).then(() => {
                this.isEdit = false
                this.changeType(this.category)
            }).catch(() => {
                this.isEdit = false
            })
            this.isEdit = false
        },
        submitEdit(formData) {
            this.isLoading = true
            let form = new FormData()
            form.append('user_id', formData.userId)
            form.append('category', formData.categoryId)
            form.append('memo_id', formData.memoId)
            form.append('content', formData.content)
            form.append('token', this.defaultToken)
            this.$store.dispatch('profile/createMemo', form).then(() => {
                this.isLoading = false
                this.isAlert = true
                setTimeout(() => {
                    this.isAlert = false
                }, 1000)

                this.isEdit = false
                this.changeType(this.category)
            }).catch(() => {
                this.isEdit = false
            })

        },
        
        scrollMenu() {
            let scrollTo = 0
            document.body.addEventListener('click', function (evt) {
                let activeItem = document.getElementsByClassName('active-item')[0]
                if (evt.target.classList.contains('menu-item')) {
                    let selectedItem = evt.target
                    activeItem.classList.remove('active-item');
                    activeItem.classList.add('menu-item');
                    selectedItem.classList.add('active-item');
                    selectedItem.classList.remove("menu-item")
                    let parent = document.getElementsByClassName('h-menu3')[0]
                    let activeIndex = Array.prototype.indexOf.call(parent.children, activeItem);
                    let selectedIndex = Array.prototype.indexOf.call(parent.children, selectedItem);
                    if (selectedIndex > activeIndex) {
                        scrollTo =  selectedItem.offsetLeft - activeItem.offsetLeft;
                    } else {
                        scrollTo =  selectedItem.offsetLeft - activeItem.offsetLeft
                        // if (scrollTo >= 0) {
                        //     scrollTo = 0;
                        // }
                    }
                    parent.scrollBy({
                        left: scrollTo,
                        behavior: 'smooth'
                    })
                } else {
                }
            }, false);
        },

        redirectBack() {
            if (this.isEdit) {
                this.isEdit = false

            } else {
                this.$router.push({name: 'profile'})
                this.setFooter(true)
            }
        },
        setScrollPosition() {
            this.scrollPosition = window.scrollY;
        },
        scrollToPosition() {
            setTimeout(() => {
                window.scrollTo(0, this.scrollPosition)
            }, 10);
        },
    }
};
</script>
<style scoped>
    .h-menu3 {
        position: unset;
    }
    #wrap3 {
        max-width: unset;
    }
    .menu {
        top: 42px;
    }

    .menu-item {
        color: #898989;
        font-weight:100
    }
    .active-item {
        pointer-events: none;
    }
</style>